@file:OptIn(InternalResourceApi::class)

package mobile_wallet.libs.mifos_passcode.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/mobile_wallet.libs.mifos_passcode.generated.resources/"

internal val Res.drawable.lib_mifos_passcode_mifos_logo: DrawableResource by lazy {
      DrawableResource("drawable:lib_mifos_passcode_mifos_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/lib_mifos_passcode_mifos_logo.jpg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("lib_mifos_passcode_mifos_logo", Res.drawable.lib_mifos_passcode_mifos_logo)
}
